import Swiper from 'swiper'

const SWIPER_CONFIG = {
  hero: {
    // loop: true,
    spaceBetween: 30,
    effect: 'fade',
    // slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: true,
  },
  gallery: {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 4,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      // when window width is >= 640px
      840: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  },
  style: {
    loop: false,
    spaceBetween: 30,
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      960: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  },
  history: {
    spaceBetween: 20,
    navigation: {
      nextEl: '.js-swiper-next',
      prevEl: '.js-swiper-prev',
    },
  },
  historyThumb: {
    spaceBetween: 10,
    slidesPerView: 7,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  },
  products: {
    loop: false,
    spaceBetween: 20,
    slidesPerView: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      960: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  },
}

export default class {
  constructor ($el, config) {
    if (typeof config === 'string') {
      config = SWIPER_CONFIG[config]
    }
    this.config = config
    this.$el = $el
  }

  init () {
    let slider = new Swiper(this.$el, this.config);
    return slider
  }
}



// WEBPACK FOOTER //
// ./scripts/components/slider.js